<ng-container #vc></ng-container>